import { render, staticRenderFns } from "./charterersTable.vue?vue&type=template&id=43505e5c"
import script from "./charterersTable.vue?vue&type=script&lang=js"
export * from "./charterersTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports